import React, { useEffect, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'

const ClickOutside = ({ children, onClickOutside, ...props }) => {
  const containerRef = useRef(null)

  const handle = useCallback(
    event => {
      let isTouch = false
      if (event.type === 'touchend') isTouch = true
      if (event.type === 'click' && isTouch) return
      if (!containerRef.current.contains(event.target)) onClickOutside(event)
    },
    [onClickOutside]
  )

  useEffect(() => {
    document.addEventListener('touchend', handle, true)
    document.addEventListener('click', handle, true)

    return () => {
      document.removeEventListener('touchend', handle, true)
      document.removeEventListener('click', handle, true)
    }
  }, [handle])

  return (
    <div className='click-outside-container' {...props} ref={containerRef}>
      {children}
    </div>
  )
}

ClickOutside.propTypes = {
  onClickOutside: PropTypes.func,
  children: PropTypes.node
}

export default ClickOutside
